import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("th", null, "Name", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, "Created", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", null, "Sent", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", null, "Viewed", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "Done", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { class: "last-child-header" }, "Actions", -1)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "survey-list__actions-glyph" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_h1 = _resolveComponent("n-h1")!
  const _component_create_icon = _resolveComponent("create-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_edit_icon = _resolveComponent("edit-icon")!
  const _component_send_icon = _resolveComponent("send-icon")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_caret_icon = _resolveComponent("caret-icon")!
  const _component_n_dropdown = _resolveComponent("n-dropdown")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_delete_icon = _resolveComponent("delete-icon")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_table = _resolveComponent("n-table")!
  const _component_ExportCSVModal = _resolveComponent("ExportCSVModal")!
  const _component_SendModal = _resolveComponent("SendModal")!
  const _component_DuplicateSurveyModal = _resolveComponent("DuplicateSurveyModal")!
  const _component_ConfirmSurveyDeleteModal = _resolveComponent("ConfirmSurveyDeleteModal")!
  const _component_CannotDeleteSurveyModal = _resolveComponent("CannotDeleteSurveyModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_n_space, { justify: "space-between" }, {
      default: _withCtx(() => [
        (_ctx.surveyRegions.size === 1 && !_ctx.isAdmin)
          ? (_openBlock(), _createBlock(_component_n_h1, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(Array.from(_ctx.surveyRegions)[0].name) + " Surveys", 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_n_h1, { key: 1 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isAdmin ? 'All' : '') + " Surveys", 1)
              ]),
              _: 1
            })),
        _createVNode(_component_n_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createSurvey()))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_n_icon, { "aria-hidden": "true" }, {
              default: _withCtx(() => [
                _createVNode(_component_create_icon)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" Create Survey ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.loaded)
      ? (_openBlock(), _createBlock(_component_n_table, {
          key: 0,
          bordered: false,
          "single-line": false,
          class: "survey-list",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_1,
                (_ctx.surveyRegions.size > 1)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_2, "Region"))
                  : _createCommentVNode("", true),
                _hoisted_3,
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                _hoisted_7
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data?.sort((a, b) => Date.parse(b.createdOn) - Date.parse(a.createdOn)), (survey) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: survey.id
                }, [
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.viewResults(survey.id)),
                    class: "admin-link"
                  }, _toDisplayString(survey.name), 9, _hoisted_8),
                  (_ctx.surveyRegions.size > 1)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(survey.region?.name), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(survey.createdOn)), 1),
                  _createElementVNode("td", null, _toDisplayString(survey.sentCount), 1),
                  _createElementVNode("td", null, _toDisplayString(survey.viewCount), 1),
                  _createElementVNode("td", {
                    class: "admin-link",
                    onClick: ($event: any) => (_ctx.viewResults(survey.id))
                  }, _toDisplayString(survey.completedCount), 9, _hoisted_10),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_n_space, {
                        justify: "start",
                        style: {"flex-flow":"nowrap"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_button, {
                            onClick: ($event: any) => (_ctx.editSurvey(survey.id)),
                            title: 
                    survey.completedCount ? 'Careful, people have completed this survey. Only fix typos and wording issues. Do not change the meaning of anything.' : 'Edit Survey'
                  
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_n_icon, { "aria-hidden": "true" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_edit_icon)
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" Edit ")
                            ]),
                            _: 2
                          }, 1032, ["onClick", "title"]),
                          _createVNode(_component_n_button_group, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_n_button, {
                                type: "primary",
                                onClick: ($event: any) => (_ctx.sendSurvey(survey.id, survey.name)),
                                disabled: _ctx.duplicatingId === survey.id
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_n_icon, { "aria-hidden": "true" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_send_icon, { alt: "" })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" Send ")
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"]),
                              _createVNode(_component_n_dropdown, {
                                trigger: "click",
                                options: _ctx.rowActionOptions,
                                onSelect: (key) => _ctx.onRowAction(key, survey)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_n_button, {
                                    type: "primary",
                                    class: "survey-list__actions-caret",
                                    disabled: _ctx.duplicatingId === survey.id,
                                    "aria-label": `More actions for ${survey.name}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_11, [
                                        (_ctx.duplicatingId === survey.id)
                                          ? (_openBlock(), _createBlock(_component_n_spin, {
                                              key: 0,
                                              size: 16,
                                              stroke: "#ffffff"
                                            }))
                                          : (_openBlock(), _createBlock(_component_n_icon, {
                                              key: 1,
                                              "aria-hidden": "true"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_caret_icon)
                                              ]),
                                              _: 1
                                            }))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled", "aria-label"])
                                ]),
                                _: 2
                              }, 1032, ["options", "onSelect"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_n_tooltip, {
                            placement: "bottom",
                            trigger: "hover"
                          }, {
                            trigger: _withCtx(() => [
                              _createVNode(_component_n_button, {
                                onClick: ($event: any) => (_ctx.deleteSurvey(survey.id)),
                                tertiary: "",
                                class: "delete-button",
                                type: "error",
                                "aria-label": 'Delete Survey' + survey.name
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_n_icon, { "aria-hidden": "true" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_delete_icon)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick", "aria-label"])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(survey?.completedCount > 0 ? 'Cannot Delete. This Survey Has Been Completed' : 'Click Here to Delete'), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ExportCSVModal, {
      survey: _ctx.exportingSurvey,
      showModal: _ctx.showExportModal,
      "onUpdate:showModal": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showExportModal) = $event))
    }, null, 8, ["survey", "showModal"]),
    _createVNode(_component_SendModal, {
      surveyId: _ctx.surveyId,
      surveyName: _ctx.surveyName,
      showModal: _ctx.showSendModal,
      "onUpdate:showModal": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showSendModal) = $event)),
      onSent: _ctx.addToSentCount
    }, null, 8, ["surveyId", "surveyName", "showModal", "onSent"]),
    _createVNode(_component_DuplicateSurveyModal, {
      survey: _ctx.selectedSurvey,
      showModal: _ctx.showDuplicateModal,
      "onUpdate:showModal": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showDuplicateModal) = $event)),
      onSurveyDuplicated: _ctx.addSurveyToList,
      onDuplicateStarted: _ctx.onDuplicateStarted,
      onDuplicateFinished: _ctx.onDuplicateFinished
    }, null, 8, ["survey", "showModal", "onSurveyDuplicated", "onDuplicateStarted", "onDuplicateFinished"]),
    _createVNode(_component_ConfirmSurveyDeleteModal, {
      survey: _ctx.selectedSurvey,
      showModal: _ctx.showConfirmDeleteModal,
      "onUpdate:showModal": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showConfirmDeleteModal) = $event)),
      onSurveyDelete: _ctx.removeSurveyFromList
    }, null, 8, ["survey", "showModal", "onSurveyDelete"]),
    _createVNode(_component_CannotDeleteSurveyModal, {
      showModal: _ctx.showCannotDeleteModal,
      "onUpdate:showModal": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showCannotDeleteModal) = $event))
    }, null, 8, ["showModal"])
  ]))
}